module.exports = __webpack_public_path__ + "img/75000.b16150ed.jpg";